import React, {useState} from 'react';
import {
    Alert,
    AlertTitle, Box, Button,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import FileCopy from '@mui/icons-material/FileCopy';
import {colorSecondary, colorText, colorWarningBackground} from "../App/theme.js";
import Snackbar from "@mui/material/Snackbar";
import Close from "@mui/icons-material/Close.js";

export const KeyBackupAlert = ({passphrase, kbId, setBackedUpDone, setBuildInBackup}) => {
    const [copyStatus, setCopyStatus] = useState('');
    const [manualBackup, setManualBackup] = useState(false);

    // Add this function to handle copying the passphrase to the clipboard
    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(generatePassphraseJSON());
            setCopyStatus('Passphrase copied to clipboard');
        } catch (error) {
            console.error('Error copying passphrase to clipboard:', error);
            setCopyStatus('Error copying passphrase to clipboard');
        }
    };

    // Add this function to generate the JSON file content
    const generatePassphraseJSON = () => {
        const data = {
            kbId: kbId,
            passphrase: passphrase,
        };
        return JSON.stringify(data, null, 2);
    };

    // Add this function to handle closing the snackbar
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setCopyStatus('');
    };

    return (
        <>
            <Alert severity="warning"
                   style={{backgroundColor: colorWarningBackground, color: colorText}}>
                <AlertTitle>Back-up Your Keys</AlertTitle>

                {!manualBackup && <>
                    <br/>
                    Before you continue, you need to back up your KB Key. You have two options:
                    <br/><br/>
                    <div style={{textAlign: 'left'}}>
                        <li><strong>Use built-in key storage:</strong> Store the key using our built-in
                            key storage.
                        </li>
                        <li><strong>Self-managed passphrase:</strong> Securely write down or store the
                            passphrase yourself, ensuring only you have the key to decrypt the content of this App.
                        </li>
                        <br/>
                        <i>We strongly recommend selecting a self-managed passphrase and backing up your
                            secrets independently, as we support Web 3.0's focus on privacy and data
                            ownership. Be aware that we cannot be held responsible for any breaches or
                            hacks if you opt for the built-in key storage service.</i>
                    </div>
                </>}

                {manualBackup && <>
                    <br/>
                    App passphrase:<br/>
                    <strong style={{color: colorSecondary}}>{passphrase}</strong>
                    <IconButton
                        edge="end"
                        color="secondary"
                        onClick={copyToClipboard}
                    >
                        <FileCopy/>
                    </IconButton>
                    <br/><br/>
                    App ID: <br/> <strong style={{color: colorSecondary}}>{kbId}</strong> <br/>
                    <br/>
                    Please make at least two copies of this passphrase to avoid the risk of losing all
                    your App content. The AES key created by this passphrase is saved only in your
                    browser's local storage, and our backend services only store encrypted copies of
                    your kbs that require your AES key or recovery passphrase to be decrypted.
                </>}

            </Alert>

            {!manualBackup &&
                <Box mt={2} display="flex" justifyContent="center">
                    <Button variant="outlined" color="secondary" onClick={() => {
                        setBuildInBackup(true);
                        setBackedUpDone(true);
                    }}>
                        I will use Built-in key storage
                    </Button>

                    <Button variant="outlined" color="secondary" onClick={() => setManualBackup(true)}
                            style={{marginLeft: '16px'}}>
                        I will manage passphrase myself
                    </Button>

                </Box>}

            {manualBackup &&
                <Box mt={2} display="flex" justifyContent="center">
                    <Button variant="outlined" color="secondary" onClick={() => {
                        setBackedUpDone(true);
                    }}>
                        I have stored the passphrase
                    </Button>
                </Box>
            }

            <Snackbar
                open={!!copyStatus}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                message={copyStatus}
                action={
                    <IconButton
                        size="small"
                        aria-label="close"
                        color="inherit"
                        onClick={handleCloseSnackbar}
                    >
                        <Close/>
                    </IconButton>
                }
            />
        </>
    );
};
